<div id="phenological-stages">
  @if (!loading) {
    @if (!wasThereAnError) {
      @if (phenologicalStagesResponse) {
        <p class="current-stage">
          <span class="label">
            {{ 'doktar_app.services.crop_monitoring.phenology.add_next_stage.current_stage' | translate }}:
          </span>
          <span>{{ currentStage?.stageName ?? '-' }}</span>
          @if (currentStage?.stageDate) {
            <span class="dot mx-2"></span>
            <span>{{ currentStage?.stageDate | luxonFormat: 'd LLLL yyyy' : 'UTC' + selectedPlantation.offSet }}</span>
          }
        </p>
        <p>
          <span class="label">{{ 'doktar_app.services.agroclimate.labels_gdd' | translate }}:</span>
          <span>{{ phenologicalStagesResponse.gdd ?? '-' }}</span>
        </p>
        <div class="year-filter-btns">
          @for (year of phenologicalStagesResponse.availableYears; track year) {
            <span class="year-filter-btn" [class.selected]="currentYear == year" (click)="onChangeCurrentYear(year)">
              {{ year }}
            </span>
          }
        </div>

        <div class="stages mt-4 pt-3">
          @for (stage of phenologicalStagesResponse?.stages; track stage.stageId; let index = $index) {
            <div
              class="step"
              [class.completed]="currentStage?.sort >= stage.sort"
              [class.last]="index === phenologicalStagesResponse?.stages.length - 1">
              <div class="v-stepper">
                <div class="circle"></div>
                <div class="line"></div>
              </div>

              <div class="content">
                <div class="stage-label">
                  {{ stage.stageName }}
                  @if (stage.stageDate) {
                    <span class="dot mx-2"></span>
                    {{ stage.stageDate | luxonFormat: 'dd.MM.yyyy' : 'UTC' + selectedPlantation.offSet }}
                  }
                </div>
                <div class="d-flex justify-content-end gap-2" style="margin-top: -10px">
                  @if (stage.stageDate) {
                    <div
                      class="menu"
                      [pTooltip]="'Edit date' | translate"
                      tooltipPosition="top"
                      (click)="updateStage(index)">
                      <i class="ph-bold ph-pencil-simple"></i>
                    </div>

                    <div
                      class="menu"
                      [pTooltip]="'Reset date' | translate"
                      tooltipPosition="top"
                      (click)="deleteStage(stage)">
                      <i class="ph-bold ph-eraser"></i>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
        @if (this.currentStageIndex < phenologicalStagesResponse.stages.length - 1) {
          <dk-button severity="secondary" (onClick)="addNextStage()">
            <span>
              {{
                'doktar_app.services.crop_monitoring.phenology.phenological_stages.add_next_stage_button'
                  | translate: { stage: phenologicalStagesResponse.stages[nextStageIndex].stageName }
              }}
            </span>
          </dk-button>
        }
      } @else {
        <div class="px-3 centerise">
          <app-weather-soil-pest-nodata-container />
        </div>
      }
    } @else {
      <div class="px-3 centerise">
        <app-weather-soil-pest-error-container
          [selectedPlantation]="selectedPlantation"
          (retry)="getPhenologicalStages()" />
      </div>
    }
  } @else {
    <p-skeleton width="100%" height="375px" />
  }
</div>
